import React, { Component } from 'react';
// import '../../App.css';
import { connect } from 'react-redux';
import { BrowserRouter as Router,Route,Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import LevelList from './editTiers/levelList.js';
import WistiaVideo from './Videos.js';
import Footer from './Footer.js';
import TopNav from '../includes/TopNav';
import {Helmet} from 'react-helmet';

const styles = {
    localH1: { 
        fontSize: '36px',
    },
    localH2: { 
        fontSize: '28px',
    },
    onlyParagraph: { 
        fontSize: '20px',
        lineHeight: '26px',
    },
    instructionList: { 
        paddingTop: '10px',
        listStyleType: 'disc',
    },
    instructionListItem: { 
        marginBottom: '15px',
    },
    question: { 
        fontSize: '24px',
        lineHeight: '26px',
        marginBottom: '10px',
    },
    answer: { 
        fontSize: '18px',
        lineHeight: '20px',
    }
}

const faqItems = [
    {
        q: 'How do I submit my paper, thesis, dissertation or journal manuscript?', 
        a: 'Easy! If you’re new to Proofreading Manuscripts, simply submit your paper here: <a href="/get-started">Get Started</a> It takes less than 3 minutes to submit your paper! If you have a thesis, dissertation, or professional journal that you need edited by one of our PhD editors, choose our Gold or Pro level in <a href="/get-started">Step 3</a> or contact us via Live Chat or via email at info@proofreadingmanuscripts.com so we can provide you with a custom editing solution.',
    },
    {
        q: 'How do I know what to expect from my editor or what will you do for my paper?',
        a: 'Check out examples of what a Gold, Silver, or Bronze level human editor can do for you here: <a href="/edit-tiers">Click Here</a>.'},
    {
        q: 'What will you edit and correct?', 
        a: 'Your editor will improve your paper by editing and correcting your: spelling, grammar, word choice, punctuation, flow, consistency, run-on sentences, sentence fragments, and punctuation. Editors will also provide comments to guide you through any necessary improvements.'
    },
    {
        q: 'Can you edit my essay FAST? Can you edit it within 3 hours? If I submit it late at night or early morning, can I get it back by the morning?', 
        a: 'Simply put, YES, YES, and YES! We offer editing in as few as 1.5 hours! We also offer 3 hour service. Once you are logged in, you can upload your essay and choose how much time you want to wait for your paper to be edited – if the option is available, you <b>WILL</b> get your paper back in that amount of time.'
    },
    {
        q: 'What if I want you to critique my paper and comment on it, not just edit it and make it read perfectly?', 
        a: 'We offer additional services for a nominal fee including: critiques, extra comments, formatting, and extra editing/ESL service. You can choose these options once you have logged in and are on the Upload page.'
    },
    {
        q: 'English is not my first language and I think my paper may need a LOT of editing. Can you help?', 
        a: 'Yes, we can! We specialize in editing ESL writing and our editors have demonstrated the ability to edit and correct all levels of papers! You should select the ESL/Extra Editing additional service when you upload your essay so your editor is able to fully correct all possible writing mistakes.'
    },
    {
        q: 'Do you edit for content or fact-check?', 
        a: 'Although we don’t fact-check or tell you if something may be factually wrong with your paper, we do generally point out obvious inaccuracies so you can correct them prior to submitting your paper to your teacher or professor. We cannot write essays from scratch or complete incomplete essays.'
    },
    {
        q: "Who are you? What's your story?", 
        a: 'Proofreading Manuscripts is based out of Toronto, Ontario, Canada. We have a team of over 100 editors across North America who are fully vetted and qualified to not only proofread, but edit your paper. We are a licensed business that is registered in Ontario and abides by all Ontario and Canadian laws. Started by a group of university graduates, Proofreading Manuscripts has grown steadily over the past two years and has become a staple for high school and university students, as well as professionals who need an accurate, affordable editor to correct their papers prior to submitting them. Our editors are actual people who are on-call 24/7 and genuinely enjoy reading, correcting, and improving your overall writing style.'
    },
    {
        q: "There's so much choice out there, why should I choose you?", 
        a: "Without going into too much detail, the internet is full of people and 'businesses' that purport to provide one thing, but give you another - often something of lower quality. Most editing companies on the internet outsource their editing to countries like India, where although their editors do speak English and may have a degree, there's a certain cultural competence that they lack. Our editors have grown up immersed in English and have been educated in one of North America's prestigious universities. Our editors are qualified, dedicated, and are not paid until you are <u>fully</u> satisfied. When completing an order, we provide you with our mailing address, telephone number, and are always available via email or live chat. Some businesses or individuals make things seem too good to be true. Our service is reasonably priced, provides an abundance of choice, and produces quick, accurate results. Choose an editor that has a reputable, Canadian business standing behind them - choose an Proofreading Manuscripts editor today!"
    },
]
class Faq extends Component{

    constructor(props) {
        super(props);
    }
    render() {
        let content = '';

        return (
            <div>
                <Helmet>
                    <title>FAQ - Frequently Asked Questions | Proofreading Manuscripts</title>
                    <meta name="description" content="These frequently asked questions can assist you in addressing whether our proofreading service is right for you."></meta>
                    <meta name="keywords" content="Edit,My,Paper,Editing,Examples,University,College,Students"></meta>
                    <meta name="author" content="proofreadingmanuscripts.com"></meta>
                    <link rel="canonical" href="https://proofreadingmanuscripts.com/faq" />
                </Helmet>
                <TopNav />
                <section className="steps top_section">
                    <div className="steps-container">
                        <h1 style={styles.localH1}>FAQ</h1>
                        <ul>

                        { faqItems.map( ( set, i ) => {
            var loc = i+1;
            return (
                <li key={"q"+i} style={styles.instructionListItem}>
                    <div style={styles.question}>
                        Question {loc}: {set.q}
                    </div>
                    <div style={styles.answer}>
                        Answer {loc}: <span dangerouslySetInnerHTML={{__html: set.a}}></span>
                    </div> 
                </li>
            )
        }) }                        
        </ul>

                    </div>
                </section>
                <Footer></Footer>
            </div>
        )
    }
}

export default connect(
  )(Faq);
  


// WEBPACK FOOTER //
// ./src/components/pages/Faq.js